var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back_light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M3 7.5L2.64645 7.85355L2.29289 7.5L2.64645 7.14645L3 7.5ZM15.5 13.5C15.5 13.7761 15.2761 14 15 14C14.7239 14 14.5 13.7761 14.5 13.5L15.5 13.5ZM6.39645 11.6036L2.64645 7.85355L3.35355 7.14645L7.10355 10.8964L6.39645 11.6036ZM2.64645 7.14645L6.39645 3.39645L7.10355 4.10355L3.35355 7.85355L2.64645 7.14645ZM3 7L9 7L9 8L3 8L3 7ZM9 7C12.5898 7 15.5 9.91015 15.5 13.5L14.5 13.5C14.5 10.4624 12.0376 8 9 8L9 7Z",
    fill: "#444444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.94b6591ac2f9fa0df44b2c9dd8522ce4.svg";
export { ForwardRef as ReactComponent };